import React, { useEffect, useState } from "react";
import {
  Button,
  LoadingComponent,
  MultiSelect,
  NoDataFoundTemplate,
  Select,
  Table,
} from "../../../../components/core";
import { useSelector, useDispatch } from "react-redux";
import {
  clearPartnerTypeSlice,
  getPartnerTypes,
} from "../../../../features/partner-types/partner-types-table-slice";
import {
  CREATE_PARTNER_TYPE,
  PARTNER_TYPE,
  UPDATE_PARTNER_TYPE,
} from "../../../../constants/graphql/partner-types-query";
import {
  useQuery,
  useMutation,
  useLazyQuery,
  operationName,
} from "@apollo/client";
import { getInitialData } from "../../../../features/partner-types/partner-types-table-slice";
import { LinearProgressBar } from "../../../../components/core";
import { useNavigate } from "react-router-dom";
import useSidebarStore from "../../../../zustand/stores/sidebar-store";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";

import { Button as PrimereactButton } from "primereact/button";
import AddPartnerTypeDialog from "./components/add-partner-dialog";
import EditPartnerTypeDialog from "./components/edit-partner-type";
export default function PartnerTypesTable() {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  //Global Utilities(Redux)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addedData = useSelector((state) => state.partnerTypesTable.addedData);
  const initialData = useSelector(
    (state) => state.partnerTypesTable.initialData
  );
  const partnerTypeFilter = useSelector(
    (state) => state.partnerTypesTable.partnerType
  );
  // Local states
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });

  //* Queries & Mutations
  const partnerTypes = useQuery(PARTNER_TYPE, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const [filterPartnerTypes, { data: filteredPartnerType, loading }] =
    useLazyQuery(PARTNER_TYPE);

  console.log({ filteredPartnerType });
  // const lockerTypes = useQuery(LOCKER_TYPES)
  const [addPartnerType] = useMutation(CREATE_PARTNER_TYPE);
  const [editPartnerType] = useMutation(UPDATE_PARTNER_TYPE);

  //* Local Hooks and States
  const [errorMessage, setErrorMessage] = React.useState({
    open: false,
    message: "",
  });
  const [filterButtonClicked, setFilterButtonClciked] = React.useState(false);
  const [isClicked, setIsClicked] = React.useState(false);

  const [openCancelModal, setOpenCancelModal] = React.useState(false);
  const [snack, setSnack] = React.useState({
    isOpen: false,
    message: "",
    type: "success",
  });
  const [updatingTable, setUpdatingTable] = React.useState(false);
  const [changesMade, setChangesMade] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const partnerCategoryList = [
    { value: 0, name: "Courier" },
    { value: 1, name: "Seller" },
  ];

  const lockerTypes = [
    { value: 1, label: "Parcel" },
    { value: 2, label: "Fridge" },
  ];

  // filter variable
  const [filterVars, setFilterVars] = useState({
    partnerType: -1,
    partnerCategory: -1,
    partnerLockerTypeAccess: [],
  });
  //*Cancel button callback
  const cancelPartnerTypes = () => {
    setOpenCancelModal(false);
    dispatch(clearPartnerTypeSlice());
    setSnack({
      isOpen: true,
      message: "Editing Canceled.",
      type: "success",
    });
  };

  // handles change of filter variables
  const handleFilterChange = (e, field) => {
    console.log({ e, field });
    setFilterVars({
      ...filterVars,
      [field]: e.target.value,
    });
  };

  useEffect(() => {
    if (filterButtonClicked) {
      filterPartnerTypes({
        variables: {
          operatorId: localStorage.getItem("user")
            ? JSON.parse(localStorage.getItem("user")).operator_id
            : "",
          lockerTypeIds:
            filterVars.partnerLockerTypeAccess.length > 0
              ? filterVars.partnerLockerTypeAccess.map((item) => item.value)
              : null,
          partnerTypeId:
            filterVars.partnerType !== -1 ? filterVars.partnerType : null,
          partnerCategoryNo:
            filterVars.partnerCategory !== -1
              ? filterVars.partnerCategory
              : null,
        },
      }).then(() => {
        setIsClicked(false);
      });
    }
  }, [filterButtonClicked, isClicked, filterPartnerTypes]);

  React.useEffect(() => {
    if (partnerTypes.data) {
      var tempData = [];
      partnerTypes.data.partnerTypes.forEach((element) => {
        tempData.push({
          partnerTypeId: element.partnerTypeId,
          partnerType: element.partnerType,
        });
      });
      dispatch(getPartnerTypes(tempData));
    }
  }, [partnerTypes.data]);

  React.useEffect(() => {
    if (filteredPartnerType && filteredPartnerType.partnerTypes) {
      var tempData = [];
      filteredPartnerType.partnerTypes.forEach((element) => {
        const partnerLockerTypeAccess = element.partnerLockerTypeAccess.map(
          (obj) => obj.lockerType.lockerType
        );
        const partnerLockerTypeAccessString =
          partnerLockerTypeAccess.join(", ");
        tempData.push({
          partnerTypeId: element.partnerTypeId,
          partnerType: element.partnerType,
          partnerCategory: element.partnerCategory.partnerCategory,
          partnerCategoryNo: element.partnerCategory.partnerCategoryNo,
          partnerLockerTypeAccess: element.partnerLockerTypeAccess,
          partnerLockerTypeAccessString: partnerLockerTypeAccessString,
          description: element.description,
          monthlyFee: element.monthlyFee,
        });
      });

      console.log({ tempData });
      dispatch(getInitialData(tempData));
    }
  }, [filteredPartnerType]);
  // console.log({ initialData });

  const handleSearch = () => {
    setIsClicked(true);
    setFilterButtonClciked(true);
  };
  console.log({ filterVars });
  return (
    <>
      <LinearProgressBar
        open={updatingTable}
        text="Table is still updating..."
      />

      {/* filtering vars */}
      <div className="grid grid-cols-12 space-y-2 w-full items-center justify-center py-3">
        <div className="col-span-6">
          <div className="grid grid-cols-5 items-center">
            <span className="col-span-2">Partner Type: </span>{" "}
            <Select
              className={`col-span-3`}
              value={filterVars.partnerType}
              items={partnerTypeFilter.map((item) => ({
                value: item.partnerTypeId,
                name: item.partnerType,
              }))}
              defaultOption={{ value: -1, name: "-- ALL --" }}
              onChange={(e) => {
                handleFilterChange(e, "partnerType");
              }}
            />
          </div>
        </div>
        <div className="col-span-6"></div>
        <div className="col-span-6">
          <div className="grid grid-cols-5 items-center">
            <span className="col-span-2">Partner Category: </span>{" "}
            <Select
              className={`col-span-3`}
              defaultOption={{ value: -1, name: "-- ALL --" }}
              items={partnerCategoryList}
              value={filterVars.partnerCategory}
              onChange={(e) => {
                handleFilterChange(e, "partnerCategory");
              }}
            />
          </div>
        </div>
        <div className="col-span-6"></div>
        <div className="col-span-6">
          <div className="grid grid-cols-5 items-center">
            <span className="col-span-2">Has Access to: </span>{" "}
            <MultiSelect
              className={`col-span-3`}
              items={lockerTypes}
              disabled={filterVars.partnerCategory === -1}
              value={filterVars.partnerLockerTypeAccess}
              placeholder={`${
                filterVars.partnerCategory === -1
                  ? "ALL Locker Type"
                  : "Select..."
              }`}
              onChange={(e) => {
                handleFilterChange(e, "partnerLockerTypeAccess");
              }}
            />
          </div>
        </div>
        <div className="col-span-6"></div>
        {/* <div className="col-span-6">
					<Button value={"Search"} className={`p-2`} />
				</div> */}

        <div className="col-span-7">
          <div></div>
          <u
            className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
            onClick={() => {
              setFilterVars({
                partnerType: -1,
                partnerCategory: -1,
                partnerLockerTypeAccess: [],
              });
            }}
          >
            <i className="fas fa-undo my-auto"></i>
            <p className="ml-1">Reset</p>
          </u>
        </div>
        <div className="col-span-5"></div>

        <div className="col-span-6">
          <Button
            value={"Search"}
            disabled={loading}
            onClick={handleSearch}
            className={"w-40 h-8"}
          />
        </div>
      </div>

      <Button
        className={`p-2 ${
          accessPermission.partnerTypes === 1 ||
          accessPermission.partnerTypes === "1"
            ? "hidden"
            : ""
        }`}
        disabled={loading}
        value="Add Partner Type"
        //   icon="pi pi-plus"
        onClick={() => {
          setOpenAddDialog(true);
        }}
      />
      {loading && <LoadingComponent />}

      {filterButtonClicked && initialData.length > 0 ? (
        accessPermission.partnerTypes === 1 ||
        accessPermission.partnerTypes === "1" ? (
          // <></>
          <Table
            headers={[
              {
                header_name: "Partner Type",
                header_key: "partnerType",
                required: true,
              },
              {
                header_name: "Partner Category",
                header_key: "partnerCategory",
                required: true,
              },
              {
                header_name: "Has Access to Locker Type",
                header_key: "partnerLockerTypeAccessString",
                required: true,
              },
              { header_name: "Description", header_key: "description" },
              {
                header_name: "Monthly Fee",
                header_key: "monthlyFee",
                required: true,
              },
            ]}
            items={initialData}
          />
        ) : (
          <>
            <Card>
              <div className="flex justify-between pb-3 items-center">
                <div>
                  Total Results:{" "}
                  <span className="font-bold">{initialData.length}</span>
                </div>
              </div>

              <DataTable
                value={initialData}
                paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                currentPageReportTemplate="Rows per page"
                paginator
                tableStyle={{
                  minWidth: "50rem",
                  borderWidth: 2,
                  borderColor: "#E6E6E6",
                }}
                paginatorRight
                rows={10}
                stripedRows
                rowsPerPageOptions={[10, 20, 50]}
                removableSort
              >
                <Column
                  header="Partner Type"
                  field="partnerType"
                  alignHeader={"center"}
                  headerClassName="bg-primary-primaryYellow"
                />
                <Column
                  header="Partner Category"
                  alignHeader={"center"}
                  sortable
                  field="partnerCategory"
                  className="text-center font-bold"
                  headerClassName="bg-primary-primaryYellow"
                />
                <Column
                  header="Has Access to Locker Type"
                  alignHeader={"center"}
                  field="partnerLockerTypeAccessString"
                  headerClassName="bg-primary-primaryYellow"
                  body={(rowData) => {
                    const tags =
                      rowData.partnerLockerTypeAccessString.split(", ");

                    return (
                      <div className="flex justify-center gap-2">
                        {tags.map((tag, index) => (
                          <Tag
                            key={index}
                            value={tag}
                            className={`${
                              tag === "Parcel"
                                ? "bg-primary-primaryYellow text-black font-bold"
                                : "bg-secondary-darkGray text-primary-primaryYellow font-bold"
                            }`}
                            // severity={getSeverity(tag)}
                          />
                        ))}
                      </div>
                    );
                  }}
                />
                <Column
                  header="Description"
                  alignHeader={"center"}
                  field="description"
                  className="max-w-[200px] break-words"
                  headerClassName="bg-primary-primaryYellow"
                />
                <Column
                  header="Monthly Fee"
                  field="monthlyFee"
                  body={(rowData) => {
                    const fee = rowData.monthlyFee;
                    // const isValidFee = typeof fee === "number" && !isNaN(fee);

                    return (
                      <div>
                        {fee ? `₱ ${fee.toLocaleString("en-US")}` : "N/A"}
                      </div>
                    );
                  }}
                  alignHeader="center"
                  headerClassName="bg-primary-primaryYellow"
                />

                <Column
                  key="action"
                  field="action"
                  headerClassName="bg-primary-primaryYellow"
                  className={`w-[120px]`}
                  // headerStyle={{ backgroundColor: "#FECD08" }}
                  body={(rowData) => (
                    <PrimereactButton
                      type="button"
                      icon={`${
                        accessPermission.behavioralCampaign === 1 ||
                        accessPermission.behavioralCampaign === "1"
                          ? "pi pi-eye"
                          : "pi pi-pencil"
                      }`}
                      className="bg-primary-primaryYellow text-black border-0 "
                      onClick={() => {
                        setOpenEditDialog(true);
                        setSelectedData(rowData);
                      }}
                    />
                  )}
                />
              </DataTable>
            </Card>
          </>
        )
      ) : (
        <NoDataFoundTemplate
          className={`${!isClicked || loading ? "hidden	" : ""}`}
        />
      )}

      <AddPartnerTypeDialog
        openAddDialog={openAddDialog}
        setOpenAddDialog={setOpenAddDialog}
        addedData={addedData}
        cancelAddPartnerType={cancelPartnerTypes}
        openCancelModal={openCancelModal}
        setOpenCancelModal={setOpenCancelModal}
        setChangesMade={setChangesMade}
        changesMade={changesMade}
      />

      <EditPartnerTypeDialog
        openEditDialog={openEditDialog}
        setOpenEditDialog={setOpenEditDialog}
        cancelEditPartnerType={cancelPartnerTypes}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        setChangesMade={setChangesMade}
        changesMade={changesMade}
      />
    </>
  );
}
